import { motion } from "framer-motion";
import { ASSETS } from "../lib/site";

export const Logo = ({ className = "", light = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} aria-label="SINOVAR">
    <img src={ASSETS.mark} alt="Sinovar" className="h-9 w-auto shrink-0 object-contain" />
    <span
      className="font-display font-extrabold tracking-tight text-[1.35rem] leading-none"
      style={{ color: light ? "#FFFFFF" : "#0B1220" }}
    >
      SINOVAR
    </span>
  </div>
);

export const LogoMark = ({ size = 40, className = "" }) => (
  <img src={ASSETS.mark} alt="Sinovar" width={size} height={size} className={`object-contain ${className}`} />
);

export const MotionLogoMark = motion(LogoMark);
